import buildUrl from 'widget/player-widget/utils/build-url';
import resizeImage from 'widget/player-widget/utils/resize-image';

import socialNetworkNames from 'widget/player-widget/constants/social-networks';

import translations from './translations';


export default function initSocialShare({ formatMessage, hosts }) {

  function buildImageUrl(coverUrl) {
    return `https:${hosts.image}${resizeImage(coverUrl)}`;
  }

  return {
    facebook: {
      name: socialNetworkNames.FACEBOOK,
      getShareUrl(content) {
        const { siteUrl, title, description, coverUrl } = content;

        return buildUrl('https://www.facebook.com/sharer/sharer.php', {
          ref: 'site',
          display: 'popup',
          picture: buildImageUrl(coverUrl),
          title,
          description,
          u: siteUrl,
          redirect_uri: 'http://musicwizard.wix.com/backend/assets/notify_parent.html',
        });
      },
    },
    twitter: {
      name: socialNetworkNames.TWITTER,
      getShareUrl(content) {
        const { siteUrl, title } = content;

        return buildUrl('https://twitter.com/intent/tweet', {
          original_referer: siteUrl,
          text: formatMessage(translations.twitter, { title, siteUrl }),
        });
      },
    },
    pinterest: {
      name: socialNetworkNames.PINTEREST,
      getShareUrl(content) {
        const { siteUrl, coverUrl, title, description } = content;

        return buildUrl('https://www.pinterest.com/pin/create/button/', {
          url: siteUrl,
          media: buildImageUrl(coverUrl),
          description: formatMessage(translations.pinterest, { title, description }),
        });
      },
    },
    tumblr: {
      name: socialNetworkNames.TUMBLR,
      getShareUrl(content) {
        const { title, siteUrl, coverUrl } = content;

        return buildUrl('https://www.tumblr.com/widgets/share/tool', {
          posttype: 'photo',
          // todo: need to find a way to resize image for tumblr
          content: buildImageUrl(coverUrl),
          caption: formatMessage(translations.tumblr, { title, siteUrl }),
          url: siteUrl,
        });
      },
    },
    link: {
      name: socialNetworkNames.LINK,
      getShareUrl: _.property('siteUrl'),
    },
  };
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/social-share/social-networks.js